<template>
  <div
    class="clientTemplates"
    :style="`width: calc(100vw - ${sideNavWidth}px)`"
  >
    <div class="wrapper">
      <pageTabHeader>
        <h5>Client Templates</h5>
        <qvoButton @click="openCreateTemplate">Create Template</qvoButton>
      </pageTabHeader>
      <tabContent>
        <div class="heading-fields">
          <textInput
            v-model="search"
            class="search-field"
            placeholder="Search templates"
            prependInnerIcon="mdi-magnify"
          />
        </div>
        <dataTable
          :headers="headers"
          :items="isLoading ? [] : list"
          item-key="ClientInfoRuleId"
          :search="search"
          :loading="isLoading"
          show-select
          @click:row="editTemplate"
          v-model="selectedTemplates"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="editTemplate(item)">
                  <v-list-item-title> Edit </v-list-item-title>
                </v-list-item>
                <v-list-item @click="createFromTemplate(item)">
                  <v-list-item-title>
                    Create Client From Template
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </dataTable>
      </tabContent>
    </div>
    <fullscreenLoader v-if="isLoadingCreateFromTemplate" />
  </div>
</template>
  
<script>
/**
 * @fileoverview Client Templates list view
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import pageTabHeader from "@/components/page-tab-header";
import tabContent from "@/components/tab-content";

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import dataTable from "@/qux-common/qux22/components/organisms/data-table";
import fullscreenLoader from "@/qux-common/qux22/components/molecules/fullscreen-loader";
import textInput from "@/qux-common/qux22/components/molecules/input";

export default {
  name: "TemplatesList",
  components: {
    dataTable,
    fullscreenLoader,
    pageTabHeader,
    tabContent,
    textInput,
    qvoButton,
  },
  data() {
    return {
      headers: [
        { text: "Template Name", value: "TemplateName" },
        { text: "Description", value: "ConfigDescription" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      search: "",
      selectedTemplates: [],
    };
  },
  computed: {
    isLoading() {
      return this.pendingCalls.includes("/client/list");
    },
    isLoadingCreateFromTemplate() {
      return this.pendingCalls.includes("/client/retrieve");
    },
    ...mapGetters({
      list: "getTemplateList",
      pendingCalls: "getPendingCallList",
      sideNavWidth: "getSideNavWidth",
      activeTenantId: "getActiveTenantId",
    }),
  },
  methods: {
    getList() {
      this.$store.dispatch("listTemplates");
    },
    openCreateTemplate() {
      this.$router.push("/clients/templates/create");
    },
    editTemplate(item) {
      this.$store.dispatch("editTemplate", {
        ClientInfoRuleId: item.ClientInfoRuleId,
        ClientId: item.ClientId,
      });
    },
    createFromTemplate(item) {
      this.$store.dispatch("createFromTemplate", {
        ClientInfoRuleId: item.ClientInfoRuleId,
        ClientId: item.ClientId,
      });
    },
  },
  watch: {
    activeTenantId() {
      this.getList();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.clientTemplates {
  height: calc(100vh - $header-height);
  .wrapper {
    height: calc(100% - $header-height);
  }
}

.heading-fields {
  margin: $qvo-spacing-8 0 $qvo-spacing-24 0;
  display: flex;
  align-items: center;
  gap: $qvo-spacing-24;
}

.content {
  padding: $qvo-spacing-24;
}

.search-field {
  width: 446px;
}

.v-data-table {
  &::v-deep {
    tr {
      cursor: pointer;
    }
  }
}

.v-list-item {
  cursor: pointer;

  &:hover {
    background: $qvo-color-grey-100;
  }
}
</style>